import { expandBaseWebBorder, expandBorderRadii } from "@gadgetinc/widgets";
import { TimeRangeIcon } from "@gadgetinc/widgets/src/icons/TimeRangeIcon";
import { useStyletron } from "baseui";
import { Card, StyledBody } from "baseui/card";
import { HeadingLevel } from "baseui/heading";
import { ParagraphMedium } from "baseui/typography";
import React from "react";
import { useHover } from "web/src/lib/hooks";
import { Pill } from "./Pill";

export const TutorialCard = (props: { title: string; time: string; body: string; link: string; topics: string[] }) => {
  const [css, $theme] = useStyletron();
  const [isHovered, hoverProps] = useHover();

  return (
    <a href={props.link || "#"} className={css({ textDecoration: "none", flex: "1" })} {...hoverProps}>
      <Card
        overrides={{
          Root: {
            style: {
              backgroundColor: isHovered ? $theme.colors.primary50 : $theme.colors.background,
              margin: "0.5rem 0",
              minWidth: "100%",
              ...expandBaseWebBorder({
                borderStyle: "solid",
                borderColor: isHovered ? $theme.colors.borderAlt : $theme.colors.border,
                borderWidth: "1.5px",
              }),
              ...expandBorderRadii($theme.borders.radius200),
            },
          },
        }}
      >
        <StyledBody>
          <HeadingLevel>
            <div className={css({ display: "flex", justifyContent: "space-between", alignItems: "baseline" })}>
              <div className={css({ marginBottom: $theme.sizing.scale200 })}>
                <span
                  className={css({
                    ...$theme.typography.HeadingSmall,
                    color: $theme.colors.contentPrimary,
                  })}
                >
                  {props.title}
                </span>
                <div
                  className={css({
                    ...$theme.typography.ParagraphSmall,
                    color: $theme.colors.contentSecondary,
                  })}
                >
                  {props.topics && <span>{props.topics.map((topic, i) => (i < props.topics.length - 1 ? `${topic}, ` : topic))}</span>}
                </div>
              </div>
              {props.time && (
                <Pill>
                  <span
                    className={css({
                      position: "relative",
                      top: "2.5px",
                      left: "-2px",
                      marginRight: "2px",
                    })}
                  >
                    <TimeRangeIcon />
                  </span>
                  {props.time}
                </Pill>
              )}
            </div>
          </HeadingLevel>
          <ParagraphMedium>{props.body}</ParagraphMedium>
        </StyledBody>
      </Card>
    </a>
  );
};
